import { pathOr } from 'ramda';
import { trackPageview } from '~/lib/analytics';
import posthogInstance from '../packs/posthog';

const ERROR_MESSAGES = {
  422: 'signUp.error.emailTaken',
};

export default {
  namespaced: true,
  state: {
    success: null,
    errorMessage: null,
  },
  mutations: {
    signUpSuccess(state, action) {
      state.success = action.payload.data;
    },
    signUpError(state, action) {
      state.errorMessage = action.errorMessage;
    },
    clearSignUpError(state) {
      state.errorMessage = null;
    },
  },
  actions: {
    signUp({ commit }, {
      email, redirect, downloadOnSuccess = false,
    }) {
      const isUSARegion = document.body.classList.contains('com');

      return new Promise((resolve, reject) => {
        const onSuccess = [];
        if (downloadOnSuccess) {
          onSuccess.push(
            {
              type: 'invoiceForm/createInvoice',
              action: 'download',
            },
            { type: 'auth/closeDialog' },
          );
        }

        const commonActions = [
          'signUp/signUpSuccess',
          'signUp/trackSignUp',
          'auth/signInSuccess',
          'config/fetchConfigData',
        ];

        const computedOnSuccess = [
          ...commonActions,
          ...(isUSARegion ? [] : ['invoices/getNewInvoice']),
          {
            type: 'flashMessages/addMessage',
            kind: 'success',
            key: 'successSignup',
            params: { email },
          },
          ...onSuccess,
        ];

        commit(
          'api/fetch',
          {
            url: '/users',
            method: 'POST',
            body: { subscription: { email } },
            promise: {
              resolve,
              reject,
            },
            onSuccess: computedOnSuccess,
            onError: ['signUp/signUpError'],
            redirect,
          },
          { root: true },
        );
      });
    },
    signUpNewbie({ commit }, { email, from_landing: fromLanding }) {
      commit(
        'api/fetch',
        {
          url: '/users',
          method: 'POST',
          body: {
            subscription: {
              email,
              from_landing: fromLanding,
            },
          },
          onSuccess: [
            'signUp/signUpSuccess',
            'signUp/trackSignUp',
            'auth/signInSuccess',
          ],
          onError: ['signUp/signUpError'],
          redirect: false,
        },
        { root: true },
      );
    },
    signUpSuccess({ commit }, payload) {
      commit('signUpSuccess', payload);
    },
    signUpError({ commit }, payload) {
      const errorCode = pathOr('', ['payload', 'response', 'status'], payload);
      const errorMessage = ERROR_MESSAGES[errorCode] || null;
      commit('signUpError', {
        ...payload,
        errorMessage,
      });
    },
    clearSignUpError({ commit }) {
      commit('clearSignUpError');
    },
    trackSignUp() {
      window.dataLayer.push({
        event: 'Purchase',
        value: 0,
        currency: document
          .getElementsByTagName('html')[0]
          .getAttribute('currency'),
        content_type: 'Trial',
      });

      const ph = posthogInstance || window.posthog;

      ph?.onFeatureFlags(() => {
        if (ph.getFeatureFlag('facebook-audience-ab') === 'remarketed') {
          window.dataLayer.push({ event: 'PurchaseCustomizedProduct' });
        }
      });

      trackPageview('trial_subscriptions');
    },
  },
};
